import { ReactNode } from "react";

import ViewHeader from "components/ViewHeader";
import ViewHeaderTitle from "components/ViewHeader/Title";
import Box from "ds/components/Box";
import ViewHeaderNavigation from "components/ViewHeader/Navigation";
import Tab from "ds/components/Tab";
import Button from "ds/components/Button";
import useCanManageIdpGroups from "shared/IdpGroup/access/useCanManageIdpGroups";

import { IdpGroupView } from "./types";
import { showIdpGroupDetailsDrawer } from "./DetailsDrawer";
import { showIdpGroupDeleteConfirmationModal } from "./ConfirmationModal";
import useDeleteGroup from "./useDeleteGroup";

type IdpGroupPageLayoutProps = {
  children: ReactNode;
  idpGroup: IdpGroupView;
};

const IdpGroupPageLayout = ({ children, idpGroup }: IdpGroupPageLayoutProps) => {
  const idpGroupUrl = `/settings/idp-group/${idpGroup.id}`;
  const canManageIdpGroups = useCanManageIdpGroups();

  const { onDelete, loading } = useDeleteGroup(["GetManagedUserGroupsV2"]);

  return (
    <>
      <ViewHeader firstLevel>
        <Box fullWidth justify="between" align="center">
          <Box gap="medium" align="center">
            <ViewHeaderTitle tag="h2">{idpGroup.groupName}</ViewHeaderTitle>
          </Box>

          <Box gap="medium" align="center">
            <Button
              variant="secondary"
              onPress={() =>
                showIdpGroupDetailsDrawer({
                  group: idpGroup,
                })
              }
            >
              Details
            </Button>
            {canManageIdpGroups && (
              <Button
                variant="dangerSecondary"
                disabled={loading}
                loading={loading}
                onPress={() =>
                  showIdpGroupDeleteConfirmationModal({
                    onConfirm: () => onDelete(idpGroup.id),
                    name: idpGroup.groupName,
                  })
                }
              >
                Delete IdP group mapping
              </Button>
            )}
          </Box>
        </Box>
        <ViewHeaderNavigation>
          <Tab end to={idpGroupUrl} label="Roles" />
          <Tab to={`${idpGroupUrl}/users`} label="Users" />
        </ViewHeaderNavigation>
      </ViewHeader>

      {children}
    </>
  );
};

export default IdpGroupPageLayout;
